import React, { useEffect, useState } from 'react'
import NavigationBar from '../../../components/Navigationbar/Navigationbar'
import { Box, Button, Card, FormControl, FormLabel, Input, Link, Table, Textarea, Typography } from '@mui/joy';
import Headline from '../../../components/headline/Headline';
import { post, Token } from '../../../Script/Session';
import { useNavigate } from 'react-router-dom';

function MeinBetrieb() {

    const [wit, setWit] = useState("90.5%");
    const [data, setdata] = useState("");
    const navigate = useNavigate();
    useEffect(() => {
        let body = {};
        body.token = Token.get();
        body.action = "get_own";
        let response = post(body, "/betriebe");
        if (response == "LOGOUT") {
            navigate("/");
            return;
        }
        setdata(JSON.parse(response));
    }, []);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [website, setWebsite] = useState("");
    const [adresse, setAdresse] = useState("");
    const [telefon, setTelefon] = useState("");
    const [rechtsform, setRechtsform] = useState("");
    const [hrnummer, setHrnummer] = useState("");
    const [steuernummer, setSteuernummer] = useState(null);
    const [vermoegenshaftpflicht, setVermoegenshaftpflicht] = useState("");
    const [vermoegenshafpflichtsumme, setVermoegenshafpflichtsumme] = useState(null);
    const [vermittlerregnummer, setVermittlerregnummer] = useState("");
    const [finanzanlagenvermittlernummer, setFinanzanlagenvermittlernummer] = useState("");
    const [aufsichtsbehoerde, setAufsichtsbehoerde] = useState("");
    const [verwaltungsprogramm, setVerwaltungsprogramm] = useState("");
    const [huskvergleich, setHuskvergleich] = useState("");
    const [programminvest, setProgramminvest] = useState("");
    const [kvlv, setKvlv] = useState("");
    const [weiteremitgliedschaften, setWeiteremitgliedschaften] = useState("");
    const [create, setcreate] = useState(false);
    function addbetrieb() {
        if (
            !name || !email || !website || !adresse || !telefon ||
            !rechtsform || !hrnummer || steuernummer == null ||
            !vermoegenshaftpflicht || vermoegenshafpflichtsumme == null ||
            !vermittlerregnummer || !finanzanlagenvermittlernummer || !aufsichtsbehoerde ||
            !verwaltungsprogramm || !huskvergleich || !programminvest ||
            !kvlv || !weiteremitgliedschaften
        ) {
            alert("Bitte alle felder ausfüllen!")
            return; 
        }
        let body = {};
        body.token = Token.get();
        body.action = "create";
        body.name = name;
        body.email = email;
        body.website = website;
        body.adresse = adresse;
        body.telefon = telefon;
        body.Rechtsform = rechtsform;
        body.hrnummer = hrnummer;
        body.steuernummer = Number(steuernummer);
        body.vermögenshaftpflicht = vermoegenshaftpflicht;
        body.vermögenshafpflichtsumme = Number(vermoegenshafpflichtsumme);
        body.vermittlerregnummer = vermittlerregnummer;
        body.finanzanlagenvermittlernummer = finanzanlagenvermittlernummer;
        body.aufsichtsbehörde = aufsichtsbehoerde;
        body.verwaltungsprogramm = verwaltungsprogramm;
        body.huskvergleich = huskvergleich;
        body.programminvest = programminvest;
        body.kvlv = kvlv;
        body.weiteremitgliedschaften = weiteremitgliedschaften;
        let response = post(body, "/betriebe");
        if (response == "LOGOUT") {
            navigate("/");
        }
        console.log(response);
        navigate("/view-betrieb/" + response);

    }



    return (
        <>
            <Box
                sx={{
                    width: wit,
                    position: "fixed",
                    top: 0,
                    right: 0,
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    bgcolor: "background.body",
                    borderLeft: "1px solid",
                    borderColor: "divider",
                    overflowY: "auto",
                }}
            >
                <Headline title="Meine Betriebe" />

                <Box sx={{ width: "98%", mt: 3, display: "flex", flexDirection: "column", gap: 2, }}>
                    {data && Object.keys(data.result).length === 0 ? (
                        <Card variant="outlined" color="neutral">
                            <Typography level="title-md">Information</Typography>
                            <Box mt={1} sx={{ flexDirection: "column", display: "flex" }}>
                                <Typography level="body-sm">
                                    Wir konnten leider keine Betriebe im Zusammenhang mit Ihnen finden.
                                </Typography>
                                <Typography level="body-sm" mt={1}>
                                    Erstellen Sie einen eigenen Betrieb oder lassen Sie sich von Ihrem Betriebsleiter hinzufügen.
                                </Typography>
                            </Box>
                            <Button onClick={() => setcreate(true)} sx={{ height: "5%", width: "10%" }}>
                                Betrieb erstellen
                            </Button>
                        </Card>
                    ) : (
                        <Card>
                            <Typography level="title-md">Betriebe</Typography>
                            <Typography mt={-1}>Unten sehen sie alle Betriebe aufgelistet zu denen sie eine Verbindung haben</Typography>
                            <Typography mt={-1}>Wenn sie trozdem einen erstellen möchten clicken sie auf diesen Knopf</Typography>
                            <Button onClick={() => setcreate(true)} sx={{ width: "10%" }}>
                                Bestrieb erstellen
                            </Button>
                        </Card>



                    )}
                    {
                        create && (
                            <Card sx={{ width: "100%", maxWidth: 700, mx: "auto", p: 3 }}>
                                <Typography level="h4" textAlign="center" mb={2}>
                                    Betrieb anlegen
                                </Typography>

                                <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
                                    <FormControl>
                                        <FormLabel>Name</FormLabel>
                                        <Input value={name} onChange={(e) => setName(e.target.value)} />
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel>Email</FormLabel>
                                        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel>Website</FormLabel>
                                        <Input type="url" value={website} onChange={(e) => setWebsite(e.target.value)} />
                                    </FormControl>

                                    <FormControl sx={{ gridColumn: "1 / -1" }}>
                                        <FormLabel>Adresse</FormLabel>
                                        <Textarea minRows={2} value={adresse} onChange={(e) => setAdresse(e.target.value)} />
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel>Telefon</FormLabel>
                                        <Input type="tel" value={telefon} onChange={(e) => setTelefon(e.target.value)} />
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel>Rechtsform</FormLabel>
                                        <Input value={rechtsform} onChange={(e) => setRechtsform(e.target.value)} />
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel>Handelsregisternummer</FormLabel>
                                        <Input value={hrnummer} onChange={(e) => setHrnummer(e.target.value)} />
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel>Steuernummer</FormLabel>
                                        <Input type="number" value={steuernummer} onChange={(e) => setSteuernummer(e.target.value)} />
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel>Vermögenshaftpflicht</FormLabel>
                                        <Input value={vermoegenshaftpflicht} onChange={(e) => setVermoegenshaftpflicht(e.target.value)} />
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel>Haftpflichtsumme</FormLabel>
                                        <Input type="number" value={vermoegenshafpflichtsumme} onChange={(e) => setVermoegenshafpflichtsumme(e.target.value)} />
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel>Vermittlerregisternummer</FormLabel>
                                        <Input value={vermittlerregnummer} onChange={(e) => setVermittlerregnummer(e.target.value)} />
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel>Finanzanlagenvermittlernummer</FormLabel>
                                        <Input value={finanzanlagenvermittlernummer} onChange={(e) => setFinanzanlagenvermittlernummer(e.target.value)} />
                                    </FormControl>

                                    <FormControl sx={{ gridColumn: "1 / -1" }}>
                                        <FormLabel>Aufsichtsbehörde</FormLabel>
                                        <Textarea minRows={2} value={aufsichtsbehoerde} onChange={(e) => setAufsichtsbehoerde(e.target.value)} />
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel>Verwaltungsprogramm</FormLabel>
                                        <Input value={verwaltungsprogramm} onChange={(e) => setVerwaltungsprogramm(e.target.value)} />
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel>HUSK-Vergleichsprogramm</FormLabel>
                                        <Input value={huskvergleich} onChange={(e) => setHuskvergleich(e.target.value)} />
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel>Vergleichsprogramm Invest</FormLabel>
                                        <Input value={programminvest} onChange={(e) => setProgramminvest(e.target.value)} />
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel>Vergleichsprogramm KVL/V</FormLabel>
                                        <Input value={kvlv} onChange={(e) => setKvlv(e.target.value)} />
                                    </FormControl>

                                    <FormControl sx={{ gridColumn: "1 / -1" }}>
                                        <FormLabel>Weitere Mitgliedschaften</FormLabel>
                                        <Textarea minRows={3} value={weiteremitgliedschaften} onChange={(e) => setWeiteremitgliedschaften(e.target.value)} />
                                    </FormControl>
                                </Box>
                                <Button onClick={() => addbetrieb()}>
                                    Erstellen
                                </Button>
                            </Card>
                        )
                    }
                    <Table
                        borderAxis="xBetween"
                        size="sm"
                        stickyHeader
                        hoverRow
                        sx={{ mt: 2, minWidth: 300 }}
                    >
                        <thead>
                            <tr>
                                <th>Betrieb</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data && data.result && data.result.map((item) => {

                                    return (<tr><td><Link href={window.location.origin + "/view-betrieb/" + item.id}>{item.name}</Link></td></tr>)
                                })
                            }
                        </tbody>
                    </Table>
                </Box>
            </Box>

            <NavigationBar state="profile" back={true} />
        </>
    )
}

export default MeinBetrieb
